import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { AddToBlacklistRequest } from './addtoblacklistrequest';

export class AddToBlacklistAPI extends SixdeeCRBTAPI<AddToBlacklistRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/add-to-black-list
        return "add-to-black-list";
    }

    getRequestData()
    {
        return "clientTxnId=11092020"+"&"+
               "language="+ this.getRequest().getAddToBlacklistRequest().getLanguage() +"&"+
               "aPartyMsisdn="+ this.getRequest().getAddToBlacklistRequest().getAPartyMsisdn() +"&"+
               "channelId="+ this.getRequest().getAddToBlacklistRequest().getChannelId() +"&"+
               "memberDetailList="+ JSON.stringify(this.getRequest().getAddToBlacklistRequest().getMemberDetails());
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/blacklist/addtoblacklist/addtoblacklistapi.tsx